

























import { Locale } from 'vue-i18n';
import { Component, Prop, Emit, Vue } from 'vue-property-decorator';
import SettingItem from '@/components/atoms/SettingItem.vue';
import CustomSelect from '@/components/atoms/neon/CustomSelect.vue';
import CustomToggle from '@/components/atoms/neon/CustomToggle.vue';
import { i18n, languages } from '@/plugins/i18n/i18n';

@Component({
  components: { SettingItem, CustomSelect, CustomToggle },
})
export default class SettingProfile extends Vue {
  @Prop()
  private language!: Locale;
  @Prop()
  private useFavorite!: boolean;
  @Prop()
  private isMultilangugeEnabled!: boolean;
  @Prop()
  private isPortalEnabled!: boolean;

  private availableLanguages: Locale[] = [];
  private selectedLanguage: Locale | null = null;

  public created(): void {
    this.availableLanguages = Object.values(languages);
    this.selectedLanguage = languages[this.language];
  }

  private get regionAndLanguage(): string {
    return i18n.tc('setting.regionAndLanguage');
  }

  private get generalSetting(): string {
    return i18n.tc('setting.generalSetting');
  }

  private get settingItemLanguage(): string {
    return i18n.tc('setting.settingItemLanguage');
  }

  private get settingItemUseFavorite(): string {
    return i18n.tc('setting.settingItemUseFavorite');
  }

  @Emit('setting-change-lang')
  private changeLanguage(value: string): Locale {
    for (var key in languages) {
      if (value === languages[key]) {
        return key;
      }
    }
    return this.language;
  }

  @Emit('change-use-favorite')
  private changeUseFavorite(value: boolean): boolean {
    return value;
  }
}
